<!--
- 专题列表组件
- anthor: wang.y
- greatTime: 2019-08-12
-->
<template>
    <li>
        <div class="collect_share">
            <i class="iconfont s active" title="取消收藏" v-if="dataLi.is_collect > 0" @click="cancelCollect('2', dataLi.id, delCollectCb)">&#xe66f;</i>
            <i class="iconfont s" title="收藏" v-else  @click="addCollect('2', dataLi.id, addCollectCb)">&#xe66f;</i>
            <Poptip trigger="hover" placement="bottom-end" padding="0" width="248" @on-popper-show="haddleShare(dataLi.uid)" @on-popper-hide="haddleShareHide">
                <i class="iconfont w">&#xe641;</i>
                <div slot="content" class="share_cnt clear">
                  <div class="share_img"></div>
                  <p>打开微信“扫一扫”<br />点击右上角分享按钮</p>
                </div>
            </Poptip>
        </div>
        <div class="cont">
            <div class="logo" @click="goEntityDetail(dataLi.uid)">
                <img :src="this.$store.state.img_req_url + dataLi.share_logo_path" class="loge-img"/>
            </div>
            <div class="spe_info">
                <p class="p1" v-html="filter.keyWordHighLight(dataLi.title, keyword)" @click="goEntityDetail(dataLi.uid)"></p>
                <p class="p2" v-if="dataLi.latest_content && dataLi.latest_content.length > 0">
                  <span>{{dataLi.update_time | time_standard}}更新</span>
                  <span>{{dataLi.latest_content[0].title}}</span>
                </p>
                <!-- <p class="p3">{{item.summary}}</p> -->
            </div>
        </div>
        <img :src="$store.state.static_img_url + 'pic/vip_tag.png'" class="vip-sp" v-if="themeState(dataLi) == 1">
        <img :src="$store.state.static_img_url + 'pic/pay_tag.png'" class="vip-sp" v-if="themeState(dataLi) == 2">
        <img :src="$store.state.static_img_url + 'pic/pay_tag2.png'" class="vip-sp" v-if="themeState(dataLi) == 3">
    </li>
</template>

<script>
import filter from 'js/filter'
import { userInfo }  from 'js/userInfo'
import { collect_mixin } from 'js/collect_mixin'
export default {
  mixins: [userInfo,collect_mixin],
  props: ['dataLi', 'keyword', 'payThemeType'],
  data() {
    return {
      filter: filter
    }
  },
  computed: {
    /**
    * 专题桩体（免费0、会员专享1、付费解锁2、已购买3）
    *  theme_id专题ID type专题类型
    */
    themeState() {
      return function(theme_item) {
        let theme_type_list = this.$store.state.theme_type
        if(theme_item.type_arr.length > 0) {
          let type_item = theme_type_list.find((a) => theme_item.type_arr[0] == a.id)
          if(type_item.price > 0 && theme_item.price > 0) {
            if(this.user_key) {
              if(this.isVIP) {
                return 1
              } else {
                let i = this.payThemeType.findIndex((a) => a.theme_type_id == theme_item.type_arr[0])
                if(i > -1) {
                  return 3
                } else {
                  return 2
                }
              }
            } else {
              return 2
            }
          } else {
            return 0
          }
        } else {
          return 0
        }
      }
    }
  },
  methods: {
    addCollectCb() {
      this.dataLi.is_collect = 1
    },
    delCollectCb() {
      this.dataLi.is_collect = 0
    },
    haddleShare(uid) {
      let share_link
      if(process.env.NODE_ENV == 'development') {
        share_link = 'http://192.168.1.104:8081/specialDetail/' + uid
      } else {
        share_link = this.$store.state.req_url+'/specialDetail/' + uid
      }

      jQuery($('.share_img')).qrcode({
        width: 80,
        height: 80,
        correctLevel: 0,
        text: share_link
      })
    },
    haddleShareHide() {
      $('.share_img').html('')
    },
    /**
    * 前往实体详情
    */
    goEntityDetail(uid) {
      const { href } = this.$router.resolve({ name: "SpecialDetail", params: { uid: uid } })
      window.open(href, '_blank')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/collect_share.stylus'
li
  float: left
  width: 326px
  height: 308px
  margin-bottom: 20px
  margin-right: 21px
  font-size: 0
  commonBgColor(#1f2330, #FFFFFF)
  position: relative
  transition_02s()
  > div.cont
    width: 326px
    height: 308px
    position: relative
    overflow: hidden
  &:nth-of-type(3n)
    margin-right: 0
  .logo
    width: 326px
    height: 204px
    position: absolute
    top: 0
    left: 0
    z-index: 2
    transition_02s()
    cursor: pointer
    img
      width: 326px
      height: 204px
    img.r-tip
      position: absolute
      right: 0
      left: auto
      bottom: 0
      z-index: 2
      width: 24px
      height: 24px
  .spe_info
    position: absolute
    commonBgColor(#1f2330, #FFFFFF)
    padding: 20px 24px
    width: 326px
    top: 204px
    z-index: 3
    transition_02s()
    .p1
      font-size: 18px
      line-height: 24px
      height: 48px
      commonColor(#e9e9eb, #333333)
      font-weight: 600
      margin: -3px 0
      ellipsisClamp2()
      cursor: pointer
      &:hover
        color: rgba(250, 122, 80, 1)
    .p2
      font-size: 12px
      line-height: 18px
      height: 18px
      commonColor(#BCBDC1, #999999)
      margin-top: 10px
      display: -webkit-box
      overflow: hidden
      text-overflow: ellipsis
      word-break: break-all
      -webkit-box-orient: vertical
      -webkit-line-clamp: 1
      transition_02s()
      span:first-of-type
        color: rgba(250, 122, 80, 1)
        margin-right: 21px
        position: relative
        &:before
          position: absolute
          content: ''
          height: 11px
          width: 1px
          commonBgColor(#40444F, #E9E9E9)
          right: -11px
          top: 1px
    >>> .high-light
      color: rgba(250, 122, 80, 1) !important
      font-style: normal
  .vip-sp
    position: absolute
    top: -5px
    left: -5px
    z-index: 2
    width: 63px
    height: 54px
  .collect_share
    position: absolute
    top: 5px
    right: 5px
    width: auto
    height: auto
    z-index: 3
    >>> .ivu-poptip
      z-index: 4
      .ivu-poptip-popper
        z-index: 4
  &:hover
    commonShadow(0 10px 30px 0 rgba(0, 0, 0, .9), 0px 10px 30px 0px rgba(121,133,143,.1))
    .logo
    .spe_info
      transform: translateY(-40px)
      .p2
        -webkit-line-clamp: 3
        height: 54px
</style>
